export default "__VITE_ASSET__CKzIXcti__"